export default function () {
  var ua = navigator.userAgent.toLowerCase()
  let platform = navigator?.userAgentData?.platform.toLowerCase() || 'unknown'
  const platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
  const isMobile = /ios|android|webos/.test(platformName)

  if (!isMobile) {
    window.__lc = window.__lc || {}
    window.__lc.license = 10998812
    ;(function () {
      var lc = document.createElement('script')
      lc.type = 'text/javascript'
      lc.async = true
      lc.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn.livechatinc.com/tracking.js'
      var s = document.getElementsByTagName('script')[0]
      s.parentNode.insertBefore(lc, s)
    })()
  }
}

export const noLiveChatScript =
  '<a href="https://www.livechatinc.com/chat-with/13203411/" rel="nofollow"> Chat with us </a> , powered by <a href="https://www.livechatinc.com/?welcome" rel="noopener nofollow" target="_blank"> LiveChat </a>'
